import {Directive, HostListener} from "@angular/core";
    
@Directive({
    selector: "[mouseup-stop-propagation]"
})
export class MouseupStopPropagation
{
    @HostListener("mouseup", ["$event"])
    public onClick(event: any): void
    {
        event.stopPropagation();
    }
}